export default __webpack_public_path__ + "static/media/templateH.eaaba5dd.png";